import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const Tracks = () => {
  const getSplits = id =>
    AuthAxios.get(`${DataApiUrl}/tracks/${id}/splits`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const addSplit = (id, user_group_payee_id, percentage, roles) =>
    AuthAxios.post(`${DataApiUrl}/tracks/${id}/splits`, {
      user_group_payee_id,
      percentage,
      roles,
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const addSplitWithContributor = (trackId, data) =>
    AuthAxios.post(`${DataApiUrl}/tracks/${trackId}/splits`, data)
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const updateSplit = (trackId, splitId, data) =>
    AuthAxios.patch(`${DataApiUrl}/tracks/${trackId}/splits/${splitId}`, data)
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const deleteSplit = (trackId, splitId) =>
    AuthAxios.delete(`${DataApiUrl}/tracks/${trackId}/splits/${splitId}`)
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const searchByIsrc = isrc =>
    AuthAxios.get(`${DataApiUrl}/admin/tracks`, { params: { isrc } })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const searchTracks = ({ search, page_size, page_index }) => {
    const params = { page_size, page_index };

    if (search.searchIsrc) params.isrc = search.searchIsrc;
    if (search.searchTitle) params.search = search.searchTitle;
    if (search.searchUpc) params.upc = search.searchUpc;

    return AuthAxios.get(`${DataApiUrl}/admin/tracks/`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  };
  const getAllFromLabel = labelId =>
    AuthAxios.get(`${DataApiUrl}/admin/tracks?user_group_id=${labelId}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getWithPassthrough = trackId =>
    AuthAxios.get(`${DataApiUrl}/admin/tracks/${trackId}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getFromList = trackIds =>
    Promise.all(trackIds.map(id => getWithPassthrough(id)))
      .then(res => res)
      .catch(err => {
        throw err.response;
      });

  return {
    getSplits,
    addSplit,
    updateSplit,
    deleteSplit,
    searchByIsrc,
    searchTracks,
    getAllFromLabel,
    getFromList,
    addSplitWithContributor,
  };
};

export default Tracks;
